import { mapState, mapGetters, mapMutations} from 'vuex';

import VirtualBackground from '@/modules/virtualBackground';

export default {
  computed: {
    ...mapState('videoRtc', ['virtualBg', 'virtualBgModel']),
    ...mapGetters(['isAmazonChime']),
  },
  methods: {
    ...mapMutations('videoRtc', ['setVirtualBgModel']),

    async loadVBModel(isDeviceSettingPage = false) {
      // load model once
      if (this.virtualBgModel) {
        return true;
      }

      // Skip BodyPix loading when not needed:
      // - Chime sessions use their own BackgroundBlurVideoFrameProcessor
      // - Agora sessions with extension support use the native VB processor
      // Only load BodyPix for: Device Setting page, SkyWay sessions, or Agora fallback
      if (!isDeviceSettingPage) {
        if (this.isAmazonChime) {
          return true;
        }

        const provider = this.$store?.state?.provider;
        const agoraVbExtensionSupported = this.agoraVbExtensionSupported !== undefined
          ? this.agoraVbExtensionSupported
          : true;

        if (provider === 'agora' && agoraVbExtensionSupported) {
          return true;
        }
      }

      const virtualBgClass = new VirtualBackground();
      this.setVirtualBgModel(virtualBgClass);
      return await virtualBgClass.loadModel();
    }
  }
}
